import {
  contractorReportOBRead,
  contractorReportOutpitRSRead,
  contractorReportRSRead,
  outpitWorkRead,
  pumpingProgressRead,
} from 'fixtures/permissions'
export const Types = [
  {
    name: 'All',
    value: 'ALL',
  },
  {
    name: 'Support Request',
    value: 'SUPPORT_REQUEST',
  },
  {
    name: 'Conformity Report',
    value: 'CONFORMITY_REPORT',
  },
  {
    name: 'Collaboration - Support Request',
    value: 'SUPPORT_REQUEST_COLLABORATION',
  },
  {
    name: 'Collaboration - Conformity Report',
    value: 'CONFORMITY_REPORT_COLLABORATION',
  },
]

export const ConformityLocations = [
  {
    value: 'DISPOSAL',
    label: 'Disposal',
  },
  {
    value: 'PIT_FRONT_LOADING',
    label: 'Pit - Front Loading',
  },
  {
    value: 'PIT_NON_FRONT_LOADING',
    label: 'Pit - Non Front Loading',
  },
  {
    value: 'GENERAL',
    label: 'General',
  },
  {
    value: 'OTHERS',
    label: 'Others',
  },
]

export const FurtherActions = [
  {
    value: true,
    label: 'Unconformity',
  },
  {
    value: false,
    label: 'Intervention',
  },
]

export const Periods = [
  {
    value: 'ALL',
    name: 'All',
  },
  {
    value: 'DAILY',
    name: 'Daily',
  },
  {
    value: 'MONTH_TO_DATE',
    name: 'Month to Date',
  },
  {
    value: 'YEAR_TO_DATE',
    name: 'Year to Date',
  },
]

export const ReportPeriods = [
  {
    id: 'DAILY',
    name: 'Daily',
  },
  {
    id: 'MONTHLY',
    name: 'Monthly',
  },
]

export const ReportTypes = [
  {
    name: 'Daily Situation',
    id: 'DAILY_SITUATION',
  },
  {
    name: 'Coal Winning',
    id: 'COAL_WINNING',
  },
  {
    name: 'OB Removal',
    id: 'OB_REMOVAL',
  },
  {
    name: 'Dumping Point',
    id: 'DUMPING_POINT',
  },
  {
    name: 'Blasting Activity',
    id: 'BLASTING_ACTIVITY',
  },
  {
    name: 'Rain and Slippery',
    id: 'RAIN_SLIPPERY',
  },
  {
    name: 'Seam',
    id: 'SEAM',
  },
  {
    name: 'Effective Working Hour',
    id: 'EFFECTIVE_WORKING_HOUR',
  },
  {
    name: 'Coal Inventory',
    id: 'COAL_INVENTORY',
  },
  {
    name: 'Equipment Status',
    id: 'EQUIPMENT_STATUS',
  },
  {
    name: 'Field Inspection',
    id: 'FIELD_INSPECTION',
  },
  {
    name: 'HM PC Coal',
    id: 'HM_PC_COAL',
  },
  {
    name: 'HM Day Work',
    id: 'HM_DAY_WORK',
  },
  {
    name: 'Daily Checklist',
    id: 'TCM_CHECKLIST_MAIN',
  },
]

export const ReportTypesIMM = [
  {
    name: 'Daily Inventory',
    id: 'IMM_DAILY_INVENTORY',
    date: true,
    month: false,
    filters: [],
  },
  {
    name: 'Safety Enviro',
    id: 'IMM_SAFETY_ENVIRO_MAIN',
    date: true,
    month: false,
    filters: ['SHIFT_ID', 'CONTRACTOR_ID', 'PIT_ID', 'USER_ID'],
  },
  {
    name: 'OB Distance Reconcile',
    id: 'IMM_DISTANCE_RECONCILE_OB',
    date: false,
    month: true,
    filters: ['SHIFT_ID'],
  },
  {
    name: 'Coal Distance Reconcile',
    id: 'IMM_DISTANCE_RECONCILE_COAL',
    date: false,
    month: true,
    filters: ['SHIFT_ID'],
  },
  {
    name: 'OB & Coal Daily Checklist',
    id: 'IMM_PIT_OPERATION_MAIN',
    date: true,
    month: false,
    filters: ['SHIFT_ID', 'CONTRACTOR_ID', 'PIT_ID', 'USER_ID'],
  },
]

export const ShiftTypes = [
  {
    name: 'All Shift',
    id: '',
  },
  {
    name: 'Day',
    id: 'DAY',
  },
  {
    name: 'Night',
    id: 'NIGHT',
  },
]

export const Severities = [
  {
    value: 'LOW',
    label: 'Low',
  },
  {
    value: 'MEDIUM',
    label: 'Medium',
  },
  {
    value: 'HIGH',
    label: 'High',
  },
]

export const Roles = [
  {
    value: 'INTERNAL',
    label: 'Internal',
  },
  {
    value: 'CONTRACTOR',
    label: 'Contractor',
  },
]

export const ContractorReports = [
  {
    name: 'Rain & Slippery',
    id: 'rainfallValidations',
    reportCode: 'RAINFALL_VALIDATION',
  },
  {
    name: 'Daily Rit Overburden',
    id: 'ritOBValidations',
    reportCode: 'RIT_OB_VALIDATION',
  },
  {
    name: 'Pumping Progress',
    id: 'pumpingProgressValidations',
    reportCode: 'PUMPING_PROGRESS_VALIDATION',
  },
  {
    name: 'Outpit Work',
    id: 'outpitWorkValidations',
    reportCode: 'OUTPIT_WORK_VALIDATION',
  },
  {
    name: 'Outpit Rain & Slippery',
    id: 'outpitRainfallValidations',
    reportCode: 'OUTPIT_RAINFALL_VALIDATION',
  },
  // {
  //   name: 'Daily Rit Coal',
  //   id: 'DAILY_RIT_COAL',
  //   reportCode: 'RIT_OB_VALIDATION',
  // }
]

export const ValidationDataTypes = [
  {
    value: 'rit_ob_validations',
    label: 'OB',
    key: 'ritOBValidations',
    permissions: contractorReportOBRead,
  },
  {
    value: 'rainfall_validations',
    label: 'R/S',
    key: 'rainfallValidations',
    permissions: contractorReportRSRead,
  },
  {
    value: 'pumping_progress_validations',
    label: 'Pumping Progress',
    key: 'pumpingProgressValidations',
    permissions: pumpingProgressRead,
  },
  {
    value: 'outpit_work_validations',
    label: 'Outpit Work',
    key: 'outpitWorkValidations',
    permissions: outpitWorkRead,
  },
  {
    value: 'outpit_rainfall_validations',
    label: 'Outpit R/S',
    key: 'outpitRainfallValidations',
    permissions: contractorReportOutpitRSRead,
  },
]

export const ValidationStatus = [
  {
    name: 'Not Validated',
    id: false,
  },
  {
    name: 'Validated',
    id: true,
  },
]

export const MineMarketStatus = [
  {
    name: 'Not Uploaded',
    id: false,
  },
  {
    name: 'Uploaded',
    id: true,
  },
]
